console.log("loading...");

const splideElement = document.querySelector('.splide');
console.log(splideElement);
const splide = splideElement.splideInstance; // Retrieve the instance


// Function to destroy and reinitialize Splide
function resetSplide(newOptions) {
  // Destroy the existing instance
  splide.destroy();

  // Create a new Splide instance with updated options
 // splide = new Splide('.splide', newOptions);

  // Mount the new instance
  //splide.mount();
}

// Call the function to reset Splide with new options
resetSplide({
  type: 'fade',
  autoplay: true,
  perPage: 1,
});

console.log('destroyed');